import API from 'types/api';
import APP from 'types/app';

const initialState = {
  isLoading: false,
  isLoaded: false,
  isError: false,
  subscriptions: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case API.GET_SUBSCRIPTION_INFO_FETCH:
      return { ...state, isLoading: true };
    case API.GET_SUBSCRIPTION_INFO_SUCCESS:
      if (payload) {
        return {
          ...state,
          subscriptions: payload,
          isLoaded: true,
          isLoading: false,
          isError: false,
        };
      }
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        isError: true,
      };
    case API.GET_SUBSCRIPTION_INFO_ERROR:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        isError: true,
      };
    case APP.RESET_SUBSCRIPTIONS_VIDEO_COLLECTIONS:
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        isError: false,
      };
    default:
      return state;
  }
};
